import React from 'react'
import { CaptionLight } from '../../../components'

export const ReorderTableHead = () => (
  <thead>
    <tr>
      <th />
      <th />
      <th>
        <CaptionLight>Managers</CaptionLight>
      </th>
      <th>
        <CaptionLight>Last edited</CaptionLight>
      </th>
      <th>
        <CaptionLight>Last activity</CaptionLight>
      </th>
    </tr>
  </thead>
)
